import React from "react";
import { connect } from "react-redux";
import { getTariffInfo } from "../../actions";

class Tariff extends React.Component {
  componentDidMount() {
    this.props.getTariffInfo();
  }

  render() {
    return this.props.children;
  }
}

export default connect(
  null,
  {
    getTariffInfo
  }
)(Tariff);


// WEBPACK FOOTER //
// ./src/components/siteInformation/tariff.js